import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetImages } from "../../store/api/ImagesApi";

function WebImagesList({ onEdit }) {
  const getImges = useGetImages();
  const {
    data: images,
    isLoading: isTopicLoading,
    error: topicError,
  } = useQuery({ queryKey: ["images"], queryFn: getImges });

  const data = images?.allImages
    ?.map((e, index) => ({
      index: index + 1,
      title: e?.title,
      image: (
        <img
          className="img-fluid shadow rounded"
          width={"150px"}
          src={e.image}
          alt={e?.title}
        />
      ),
      actionButton: (
        <>
          <button onClick={() => onEdit(e)} className="btn text-success mx-2">
            <MdEditDocument />
          </button>
        </>
      ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Title",
      accessor: "title",
    },
    {
      header: "Image",
      accessor: "image",
    },
    {
      header: "Actions",
      accessor: "actionButton",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isTopicLoading} />
    </div>
  );
}

export default WebImagesList;
